import React, { FC } from 'react';
import { Checkbox } from '@mantine/core';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import styles from './TabletFilterCheckbox.module.scss';

export interface FilterCheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  disabled?: boolean;
  inn?: string;
}

export const TabletFilterCheckbox: FC<FilterCheckboxProps> = ({
  checked,
  onChange,
  label,
  disabled = false,
  inn,
}) => {
  const labelWithInn = inn ? (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <span style={{ height: '24px' }}>{label}</span>
      <p style={{ height: '14px', fontSize: '14px', color: '#666666' }}>ИНН {inn}</p>
    </div>
  ) : (
    label
  );
  const lableData = <TextWithTooltip content={label} className={styles.lable} />;
  return (
    <Checkbox
      color='#002CFB'
      size='20px'
      checked={checked}
      onChange={onChange}
      label={labelWithInn}
      disabled={disabled}
      styles={{
        body: {
          alignItems: 'center',
        },
        label: {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#121922',
          cursor: 'pointer',
          maxWidth: '300px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        inner: {
          height: '22px',
          display: 'flex',
          alignItems: 'center',
        },
        input: {
          border: checked ? '2px solid #002CFB' : '2px solid rgba(173, 191, 223, 0.40)',
          cursor: 'pointer',
        },
      }}
    />
  );
};
